import { inject, Injectable } from '@angular/core';
import { map, Observable, of, shareReplay, tap } from 'rxjs';
import { CoreApiService } from './core-api.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  sessionStorageService = inject(SessionStorageService);

  userInfo: any = null;
  private userRoles: string[] = [];
  private userInfo$: Observable<string[]> | null = null;

  constructor(private apiService: CoreApiService) {}

  // Fetches roles if they haven't been fetched yet, otherwise returns cached roles.
  getRoles(): Observable<string[]> {
    if (this.userRoles.length > 0) {
      return of(this.userRoles);
    }
    if (!this.userInfo$ && this.sessionStorageService.getItem('idToken')) {
      this.userInfo$ = this.apiService.getUserRoles().pipe(
        map(({ data }: any) => {
          this.userInfo = data;
          if (!Array.isArray(this.userInfo.roles)) {
            return [];
          }
          return data!.roles.map((item: any) => item.name);
        }),
        tap((roles) => {
          this.userRoles = roles;
        }),
        shareReplay(1) // Cache the result
      );
    }

    if (!this.userInfo$) {
      return of([]);
    }
    return this.userInfo$;
  }

  getConaId(switchIdOrConaId: boolean = false) {
    if (this.userInfo) {
      if (switchIdOrConaId && this.userInfo.switchUser) {
        return this.userInfo.switchUser;
      }
      return this.userInfo.conaId;
    }
    return null;
  }

  // Checks if the user has a specific required role.
  hasRole(requiredRole: string): boolean {
    return this.userRoles.includes(requiredRole);
  }

  // Checks if the user has any of the required roles.
  hasAnyRole(requiredRoles: string[]): boolean {
    return requiredRoles.some((role) => this.hasRole(role));
  }

  // Clears roles on logout.
  clearRoles(): void {
    this.userRoles = [];
  }
}
